import React from "react";
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
import { Image } from "primereact/image";
import { useParams, useNavigate } from "react-router-dom";
import { ROUTES } from "@navigation";
import { getGalleryConfig } from "./utils";
import { HOOKS_MAP } from "./constants";

export function GalleryView() {
  const { type } = useParams<{ type: string }>();
  const navigate = useNavigate();

  const config = getGalleryConfig(type, HOOKS_MAP);
  const { data, loading } = config
    ? config.hook()
    : { data: [], loading: false };

  if (!config) return <p className="p-4">Invalid gallery type</p>;
  if (loading) return <p className="p-4">Loading...</p>;

  const breadcrumbItems = [
    { label: "Website Graphics", command: () => navigate(-1) },
    { label: config.title },
  ];

  return (
    <div className="p-4">
      <BreadCrumb
        model={breadcrumbItems}
        home={{
          icon: "pi pi-home",
          command: () => navigate(`${ROUTES.ADMIN}/${ROUTES.DASHBOARD}`),
        }}
        className="mb-4"
      />

      <div className="grid">
        {data.map((item: any) => (
          <div key={item.id} className="col-12 sm:col-6 md:col-4 lg:col-3 p-2">
            <div className="border-round-lg overflow-hidden surface-card shadow-1 hover:shadow-4 transition-all relative group cursor-pointer">
              <div className="h-12rem w-full bg-gray-100 flex align-items-center justify-content-center overflow-hidden relative">
                {item[config.imageKey] ? (
                  <Image
                    src={item[config.imageKey]}
                    alt={item[config.nameKey] || "Image"}
                    preview
                    imageClassName="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                ) : (
                  <span className="text-500">No image</span>
                )}

                {item[config.imageKey] && (
                  <div className="absolute top-0 left-0 w-full h-full bg-black-alpha-50 opacity-0 group-hover:opacity-100 flex align-items-center justify-content-center transition-all pointer-events-none">
                    <i className="pi pi-eye text-white text-4xl" />
                  </div>
                )}
              </div>

              {item[config.nameKey] && (
                <div className="p-2 text-sm font-medium text-900 truncate">
                  {item[config.nameKey]}
                </div>
              )}

              <div className="absolute top-0 right-0 m-1 hidden group-hover:block">
                <Button
                  icon="pi pi-ellipsis-v"
                  className="p-button-rounded p-button-text p-button-sm"
                  onClick={() => console.log("Menu clicked", item.id)}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
